import { render, staticRenderFns } from "./BusinessNameEscalationFile.vue?vue&type=template&id=c2d64780&scoped=true&"
import script from "./BusinessNameEscalationFile.vue?vue&type=script&lang=js&"
export * from "./BusinessNameEscalationFile.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameEscalationFile.vue?vue&type=style&index=0&id=c2d64780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d64780",
  null
  
)

export default component.exports